import { polyfill } from 'es6-promise'
import { BACKEND_URL } from '../env'; polyfill()
const Vue = require('vue')
export class StatisticsService {
  static get entity () {
    return 'used_for_replacement'
  }

  static incrementReplacementCounter (pk) {
    // console.log('service:  ' + data)
    return new Promise((resolve, reject) => {
      const myHeaders = new Headers()
      let token = Vue.default.cookie.get('token')
      if (!token) {
        token = localStorage.getItem('genderAppToken')
      }
      myHeaders.append('Authorization', `Token ${token}`)
      myHeaders.append('Content-Type', 'application/json')
      const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: {},
        redirect: 'follow'
      }
      fetch(BACKEND_URL + `/dictionary_entry/used_for_replacement/${pk}/`, requestOptions)
    })
  }

  static logLogin () {
    // console.log('service:  ' + data)
    return new Promise((resolve, reject) => {
      const myHeaders = new Headers()
      let token = Vue.default.cookie.get('token')
      if (!token) {
        token = localStorage.getItem('genderAppToken')
      }
      myHeaders.append('Authorization', `Token ${token}`)
      myHeaders.append('Content-Type', 'application/json')
      const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: {},
        redirect: 'follow'
      }
      fetch(BACKEND_URL + '/addin_usage_log/login_log/', requestOptions)
    })
  }

  static logAnalysedParagraph () {
    // console.log('service:  ' + data)
    return new Promise((resolve, reject) => {
      const myHeaders = new Headers()
      let token = Vue.default.cookie.get('token')
      if (!token) {
        token = localStorage.getItem('genderAppToken')
      }
      myHeaders.append('Authorization', `Token ${token}`)
      myHeaders.append('Content-Type', 'application/json')
      const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: {},
        redirect: 'follow'
      }
      fetch(BACKEND_URL + '/addin_usage_log/analysed_paragraph_log/', requestOptions)
    })
  }

  static logSearch (searchTerm) {
    const data = {
      searchTerm: searchTerm
    }
    // console.log('service:  ' + data)
    return new Promise((resolve, reject) => {
      const myHeaders = new Headers()
      let token = Vue.default.cookie.get('token')
      if (!token) {
        token = localStorage.getItem('genderAppToken')
      }
      myHeaders.append('Authorization', `Token ${token}`)
      myHeaders.append('Content-Type', 'application/json')
      const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: 'follow'
      }
      fetch(BACKEND_URL + '/addin_usage_log/search_log/', requestOptions)
    })
  }

  static logReplacement (searchTerm, replacementPk) {
    // console.log('service:  ' + data)
    const data = {
      searchTerm: searchTerm,
      replacementPk: replacementPk
    }
    return new Promise((resolve, reject) => {
      const myHeaders = new Headers()
      let token = Vue.default.cookie.get('token')
      if (!token) {
        token = localStorage.getItem('genderAppToken')
      }
      myHeaders.append('Authorization', `Token ${token}`)
      myHeaders.append('Content-Type', 'application/json')
      const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: 'follow'
      }
      fetch(BACKEND_URL + '/addin_usage_log/replace_log/', requestOptions)
    })
  }
}
